var render = function (_h,_vm) {var _c=_vm._c;return _c('span',{staticClass:"icon",class:("icon--" + (_vm.props.icon))},[_c('svg',[_c('title',[_vm._v(_vm._s(_vm.props.icon))]),_c('use',{attrs:{"xlink:href":("#icon--" + (_vm.props.icon))}})])])}
var staticRenderFns = []

export { render, staticRenderFns }